module.exports = __webpack_public_path__ + "static/img/dcfw.175d25f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/linshi/dcfw.png
// module id = B6Yo
// module chunks = 44